import { ICellRendererAngularComp, IHeaderAngularComp } from 'ag-grid-angular';
import { ICellRendererParams, IHeaderParams } from 'ag-grid-community';
import { Component } from '@angular/core';

@Component({
  selector: 'pt-select-cell-editable-renderer',
  template: `
    <div class="fake-select" *ngIf="showSelect">
      <div class="text">{{currentValue}}</div>
      <ion-icon class="icon" name="caret-down-outline"></ion-icon>
    </div>
    <div class="fake-text" *ngIf="!showSelect">
      <div class="text">{{currentValue}}</div>
    </div>
  `,
  styles: [`
    .fake-text {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 5px;
      background: transparent;
    }
    .fake-select {
      width: 100%;
      height: 100%;
      border: 1px solid #33333333;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 5px;
      background: white;
    }

    .fake-select .text {
      display: block;
      width: calc(100% - 20px);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .fake-select .icon {
      color: #333;
      width: 20px;
    }
  `]
})
export class SelectCellEditableRendererComponent implements ICellRendererAngularComp, IHeaderAngularComp {
  params: any;
  currentValue: string;
  showSelect = false;

  agInit(params: any): void {
    this.params = params;
    this.showSelect = this.params.showSelect
    const value = params.value;
    this.currentValue = params.formatValue(value);
  }

  refresh(params: ICellRendererParams): boolean;
  refresh(params: IHeaderParams): boolean;
  refresh(params: ICellRendererParams | IHeaderParams): boolean {
    return false;
  }
}
